"use client";

import Link from "next/link";
import type { MouseEventHandler } from "react";
import { useState } from "react";
import { GateGlyph } from "@/components/brand/gate-glyph";
import { Button } from "@/components/ui/button";
import { useMotionPreference } from "@/hooks/use-motion-preference";
import { APP_URL } from "@/lib/links";
import { cn } from "@/lib/utils";

interface PortalCtaButtonProps {
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  size?: "sm" | "default" | "lg";
}

export function PortalCtaButton({ className, onClick, size = "lg" }: PortalCtaButtonProps) {
  const { reducedMotion } = useMotionPreference();
  const [active, setActive] = useState(false);
  const animateGate = active && !reducedMotion;

  return (
    <Button
      asChild
      variant="gradient"
      size={size}
      className={cn("group relative overflow-hidden px-7", className)}
    >
      <Link
        href={APP_URL}
        onClick={onClick}
        onBlur={() => setActive(false)}
        onFocus={() => setActive(true)}
        onMouseEnter={() => setActive(true)}
        onMouseLeave={() => setActive(false)}
      >
        <span className="relative transition-opacity duration-200 group-hover:opacity-0 group-focus-visible:opacity-0">
          Enter moongate
        </span>
        <span
          aria-hidden
          className="absolute inset-0 grid place-items-center text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-focus-visible:opacity-100"
        >
          <GateGlyph
            key={animateGate ? "active" : "rest"}
            size={14}
            className="text-white"
            animated={animateGate}
          />
        </span>
      </Link>
    </Button>
  );
}
